module.exports = __webpack_public_path__ + "static/media/footer-scene-gya.78d17c4f.png";